<template>
  <div class="customer-contract-preview-container">
    <!-- 调试信息 -->
    <div class="debug-panel" v-if="false">
      <h3>调试信息</h3>
      <p>合同ID: {{ contractId }}</p>
      <p>路由路径: {{ $route.path }}</p>
      <p>路由名称: {{ $route.name }}</p>
      <p>加载状态: {{ loading ? '加载中' : '已完成' }}</p>
      <p>API响应: {{ apiResponse }}</p>
      <p>API错误: {{ apiError }}</p>
      <div class="debug-actions">
        <el-button @click="retryFetch" type="primary" size="small">重试获取数据</el-button>
        <el-button @click="showDebug = false" type="info" size="small">隐藏调试信息</el-button>
      </div>
    </div>
    
    <el-alert
      v-if="error"
      :title="error"
      type="error"
      :closable="false"
      show-icon>
    </el-alert>

    <div v-if="loading" class="loading-container">
      <el-skeleton animated :rows="10" />
    </div>
    
    <div v-else class="contract-content">
    <!-- 顶部导航栏 -->
      <div class="top-nav" v-if="false">
        <div class="company-info">{{ contractInfo.customer_name }}</div>
        <div class="contract-info">{{ contractInfo.title }}</div>
    </div>
    
    <!-- 合同标题 -->
      <h2 class="contract-title">{{ contractInfo.title }}</h2>
    
    <!-- 合同清单标题 -->
    <div class="section-title">
        <h3>合同清单</h3>
      <div class="divider"></div>
    </div>
    
    <!-- 合同商品明细表格 -->
    <el-table
        :data="contractItems"
      border
      style="width: 100%"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
    >
      <el-table-column prop="category" label="分类" width="80" align="center"></el-table-column>
      <el-table-column prop="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="material_name" label="材料名称" min-width="150" align="center"></el-table-column>
        <el-table-column prop="spec_model" label="规格型号" min-width="200" align="center"></el-table-column>
      <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
      <el-table-column prop="quantity" label="数量" width="80" align="center"></el-table-column>
        <el-table-column prop="unit_price" label="税前单价（元）" width="120" align="center"></el-table-column>
      <el-table-column prop="tax_rate" label="税率" width="80" align="center">
        <template slot-scope="scope">
          {{ formatTaxRate(scope.row.tax_rate) }}
        </template>
      </el-table-column>
        <el-table-column prop="tax_price" label="含税单价（元）" width="120" align="center"></el-table-column>
    </el-table>
    
    <!-- 基本信息标题 -->
    <div class="section-title">
      <h3>基本信息</h3>
      <div class="divider"></div>
    </div>
    
    <!-- 基本信息内容 -->
    <div class="info-container">
      <el-row :gutter="0" class="info-row">
        <el-col :span="6" class="info-label">
          <div class="label-container">供应商名称</div>
        </el-col>
        <el-col :span="18" class="info-value">
          <div class="value-container">{{ contractInfo.customer_name }}</div>
        </el-col>
      </el-row>
      
      <el-row :gutter="0" class="info-row">
          <el-col :span="4" class="info-label">
          <div class="label-container">交货时间</div>
        </el-col>
          <el-col :span="8" class="info-value">
          <div class="value-container">{{ contractInfo.delivery_time }}</div>
        </el-col>
          <el-col :span="4" class="info-label">
          <div class="label-container">计价方式</div>
        </el-col>
          <el-col :span="8" class="info-value">
          <div class="value-container">{{ contractInfo.pricing_method }}</div>
        </el-col>
      </el-row>
      
      <el-row :gutter="0" class="info-row">
          <el-col :span="4" class="info-label">
          <div class="label-container">结算时间</div>
        </el-col>
          <el-col :span="8" class="info-value">
            <div class="value-container">{{ contractInfo.settlement_method }}</div>
        </el-col>
          <el-col :span="4" class="info-label">
            <div class="label-container">付款方式</div>
        </el-col>
          <el-col :span="8" class="info-value">
            <div class="value-container">{{ contractInfo.payment_method }}</div>
        </el-col>
      </el-row>
      
      <el-row :gutter="0" class="info-row">
          <el-col :span="4" class="info-label">
            <div class="label-container">是否计息</div>
        </el-col>
          <el-col :span="8" class="info-value">
            <div class="value-container">{{ contractInfo.is_interest }}</div>
        </el-col>
      </el-row>
      
      <el-row :gutter="0" class="info-row">
          <el-col :span="4" class="info-label">
            <div class="label-container">计息条件</div>
        </el-col>
          <el-col :span="20" class="info-value">
            <div class="value-container">{{ contractInfo.interest_conditions }}</div>
        </el-col>
      </el-row>
      </div>
    </div>
    
    <!-- 底部操作按钮 -->
    <div class="action-buttons">
      <el-button @click="goBack" type="primary">返回</el-button>
      <el-button v-permission="'contracts:contract-view:print'" @click="printContract" type="primary" plain>打印</el-button>
    </div>
  </div>
</template>

<script>
import { getContractById } from '@/api/modules/contracts.js';
import { installPlatformPrintFooter } from '@/utils/print-footer';

export default {
  name: 'CustomerContractPreview',
  data() {
    return {
      contractId: null,
      contractInfo: {
        title: '',
        customer_name: '',
        customerProject: '',
        settlement_time: '',
        payment_method: '',
        settlement_method: '',
        interest_conditions: '',
        pricing_method: '',
        is_measure: false,
        isMeasured: false,
        total_amount: '',
        remark: '',
        confirmed: false
      },
      productList: [],
      contractItems: [],
      loading: false,
      error: null,
      showDebug: true,
      apiResponse: '无',
      apiError: '无'
    };
  },
  created() {
// 获取路由参数中的合同ID
    this.contractId = this.$route.params.id;
    if (this.contractId) {
this.fetchContractData(this.contractId);
    } else {
      console.error('合同ID不存在');
      this.error = '合同ID不存在，无法获取合同详情';
    }
  },
  methods: {
    // 重试获取数据
    retryFetch() {
this.fetchContractData(this.contractId);
    },
    
    // 获取合同详情
    fetchContractData(id) {
      if (!id) {
        this.error = '合同ID不存在，无法获取合同详情';
        return;
      }
      
      // 对于新建的合同，使用特殊处理
      if (id === 'new') {
        this.error = '新建合同尚未保存，无法预览详情';
        this.loading = false;
        return;
      }
      
      this.loading = true;
      this.error = null;
getContractById(id)
        .then(response => {
this.apiResponse = JSON.stringify(response.data, null, 2);
          
          if (response.data && response.data.success) {
            const contractData = response.data.data;
            try {
              // 打印付款相关信息
// 从contractParties中提取客户信息
              let customerNames = [];
              if (contractData.contractParties && contractData.contractParties.length > 0) {
                const customers = contractData.contractParties.filter(party => party.partyType === 'CUSTOMER');
                customerNames = customers.map(customer => customer.unitInfo?.unitName || '未知客户');
              }
              
              // 设置合同基本信息
              this.contractInfo = {
                title: contractData.contractName || '客户合同',
                customer_name: customerNames.join('，') || '',
                customerProject: customerNames.join('，') || '',
                // 合同基本信息字段调整
                delivery_time: contractData.contractDate ? contractData.contractDate.split('T')[0] : '',
                payment_method: this.formatPaymentMethod(
                  contractData.settlementMethod,
                  contractData.payment70PercentDays || 30,
                  contractData.paymentFullDays || 90
                ),
                settlement_method: contractData.settlementMethod || '每月20日结算',
                interest_conditions: this.formatInterestConditions(contractData),
                pricing_method: contractData.pricingMethod === 'FIXED' ? '固定价' : '变动价',
                is_interest: contractData.interestCalculation ? '是' : '否',
                total_amount: contractData.contractAmount || '框架合同，具体金额以实际供货量为准',
                remark: contractData.remark || '',
                confirmed: contractData.status === 'ACTIVE'
              };
              
              // 处理客户信息 - 新API结构中的customers字段
              if (contractData.customers && contractData.customers.length > 0) {
// 从customers数组中提取客户信息
                const customerNames = contractData.customers.map(item => {
                  // 获取客户信息
                  const customerInfo = item.customer || {};
                  return customerInfo.unit_name || '未知客户';
                });
                
                // 设置客户名称
                if (customerNames.length > 0) {
                  this.contractInfo.customer_name = customerNames.join('，');
}
              }
              
              // 添加一个递归搜索函数，寻找所有可能的客户名称信息
              const findCustomerInfo = (obj, path = '') => {
                const results = [];
                
                if (!obj || typeof obj !== 'object') return results;
                
                // 检查是否有可能包含客户名称的字段
                const nameFields = ['customer_name', 'unit_name', 'name', 'partyA', 'party_a'];
                const customerObjFields = ['Customer', 'customer', 'Party_A', 'PartyA', 'customerInfo'];
                const projectFields = ['project_name', 'projectName', 'name'];
                
                // 直接检查当前对象的字段
                for (const field of nameFields) {
                  if (obj[field] && typeof obj[field] === 'string' && obj[field].trim() !== '') {
                    results.push({
                      path: path ? `${path}.${field}` : field,
                      value: obj[field],
                      type: 'name'
                    });
                  }
                }
                
                // 检查客户对象
                for (const field of customerObjFields) {
                  if (obj[field] && typeof obj[field] === 'object') {
                    const customerObj = obj[field];
                    for (const nameField of nameFields) {
                      if (customerObj[nameField] && typeof customerObj[nameField] === 'string' && customerObj[nameField].trim() !== '') {
                        results.push({
                          path: path ? `${path}.${field}.${nameField}` : `${field}.${nameField}`,
                          value: customerObj[nameField],
                          type: 'customer_object'
                        });
                      }
                    }
                  }
                }
                
                // 检查是否有客户和项目配对信息
                if (obj.Customer && obj.Project) {
                  let customerName = '';
                  let projectName = '';
                  
                  // 获取客户名称
                  for (const field of nameFields) {
                    if (obj.Customer[field] && typeof obj.Customer[field] === 'string') {
                      customerName = obj.Customer[field];
                      break;
                    }
                  }
                  
                  // 获取项目名称
                  for (const field of projectFields) {
                    if (obj.Project[field] && typeof obj.Project[field] === 'string') {
                      projectName = obj.Project[field];
                      break;
                    }
                  }
                  
                  if (customerName && projectName) {
                    results.push({
                      path: path ? `${path}.Customer_Project` : 'Customer_Project',
                      value: `${customerName}/${projectName}`,
                      type: 'customer_project_pair',
                      customerName,
                      projectName
                    });
                  }
                }
                
                // 递归检查数组
                if (Array.isArray(obj)) {
                  obj.forEach((item, index) => {
                    const newPath = path ? `${path}[${index}]` : `[${index}]`;
                    results.push(...findCustomerInfo(item, newPath));
                  });
                  return results;
                }
                
                // 递归检查对象的所有属性
                for (const key in obj) {
                  if (Object.prototype.hasOwnProperty.call(obj, key) && typeof obj[key] === 'object' && obj[key] !== null) {
                    const newPath = path ? `${path}.${key}` : key;
                    results.push(...findCustomerInfo(obj[key], newPath));
                  }
                }
                
                return results;
              };
              
              // 如果新API的customers结构没有成功处理，尝试使用递归搜索
              if (!this.contractInfo.customer_name && contractData) {
                const allCustomerInfo = findCustomerInfo(contractData);
                
                if (allCustomerInfo.length > 0) {
                  // 优先使用customer_project_pair类型的结果
                  const customerProjectPairs = allCustomerInfo.filter(info => info.type === 'customer_project_pair');
                  if (customerProjectPairs.length > 0) {
                    this.contractInfo.customer_name = customerProjectPairs.map(info => info.value).join('，');
}
                  // 如果没有找到客户/项目对，尝试组合客户和项目信息
                  else {
                    // 查找所有客户名称
                    const customers = allCustomerInfo.filter(info => 
                      info.type === 'customer_object' || 
                      (info.path && (info.path.includes('Customer') || info.path.includes('customer')))
                    );
                    
                    // 查找所有项目名称
                    const projects = findCustomerInfo(contractData).filter(info => 
                      info.path && (
                        info.path.includes('Project.project_name') || 
                        info.path.includes('project.name') || 
                        info.path.includes('projectName')
                      )
                    );
                    
if (customers.length > 0) {
                      if (projects.length > 0) {
                        // 如果客户和项目数量相同，尝试一一对应
                        if (customers.length === projects.length) {
                          const pairs = customers.map((customer, index) => 
                            `${customer.value}/${projects[index].value}`
                          );
                          this.contractInfo.customer_name = pairs.join('，');
                        } 
                        // 否则，使用第一个客户名称和所有项目名称
                        else {
                          const customerName = customers[0].value;
                          const projectList = projects.map(p => p.value).join('，');
                          this.contractInfo.customer_name = `${customerName}/${projectList}`;
                        }
                      } else {
                        // 只有客户名称，没有项目名称
                        this.contractInfo.customer_name = customers.map(c => c.value).join('，');
                      }
}
                    // 如果上面的方法都失败，使用之前的逻辑
                    else {
                      const customerObjResults = allCustomerInfo.filter(info => info.type === 'customer_object');
                      if (customerObjResults.length > 0) {
                        this.contractInfo.customer_name = customerObjResults.map(info => info.value).join('，');
                      } else {
                        this.contractInfo.customer_name = allCustomerInfo.map(info => info.value).join('，');
                      }
}
                  }
                }
              }
              
              // 设置商品列表 - 使用新API的contractItems字段
              if (contractData.contractItems && Array.isArray(contractData.contractItems) && contractData.contractItems.length > 0) {
                this.contractItems = contractData.contractItems.map((item, index) => {
                  return {
                    category: item.remark || '未分类',
                    index: index + 1,
                    material_name: item.productName || '',
                    spec_model: item.specification || '',
                    unit: item.unit || '',
                    quantity: item.quantity || '/',
                    unit_price: item.unitPrice ? Number(item.unitPrice).toFixed(2) : '0.00',
                    tax_rate: '0', // 新API中没有税率字段
                    tax_price: item.totalAmount ? Number(item.totalAmount).toFixed(2) : '0.00'
                  };
                });
} else if (contractData.contract_items && Array.isArray(contractData.contract_items)) {
this.contractItems = contractData.contract_items.map((item, index) => {
                  return {
                    category: item.category || '未分类',
                    index: index + 1,
                    material_name: item.material_name || item.name || '',
                    spec_model: item.spec_model || item.specification || '',
                    unit: item.unit || '',
                    quantity: item.quantity || '/',
                    unit_price: item.unit_price ? Number(item.unit_price).toFixed(2) : 
                               (item.price ? Number(item.price).toFixed(2) : '0.00'),
                    tax_rate: item.tax_rate 
                      ? (typeof item.tax_rate === 'string'
                         ? parseFloat(item.tax_rate).toFixed(0)
                         : item.tax_rate)
                      : '0',
                    tax_price: item.tax_price ? Number(item.tax_price).toFixed(2) : 
                               (item.tax_included_price ? Number(item.tax_included_price).toFixed(2) : '0.00')
                  };
                });
              }
              
              // 检查contractItems是否为空，如果为空则添加测试数据以便调试
              if ((!this.contractItems || this.contractItems.length === 0) && contractData.contract_items) {
this.contractItems = contractData.contract_items.map((item, index) => {
                  return {
                    category: item.category || '未分类',
                    index: index + 1,
                    material_name: item.material_name || item.name || '',
                    spec_model: item.spec_model || item.specification || '',
                    unit: item.unit || '',
                    quantity: item.quantity || '/',
                    unit_price: item.unit_price ? Number(item.unit_price).toFixed(2) : 
                               (item.price ? Number(item.price).toFixed(2) : '0.00'),
                    tax_rate: item.tax_rate 
                      ? (typeof item.tax_rate === 'string'
                         ? parseFloat(item.tax_rate).toFixed(0)
                         : item.tax_rate)
                      : '0',
                    tax_price: item.tax_price ? Number(item.tax_price).toFixed(2) : 
                               (item.tax_included_price ? Number(item.tax_included_price).toFixed(2) : '0.00')
                  };
                });
              }
              
              // 如果仍然没有数据，添加测试数据
              if (!this.contractItems || this.contractItems.length === 0) {
this.contractItems = [
                  {
                    category: '钢材',
                    index: 1,
                    material_name: 'Q235B螺纹钢',
                    spec_model: 'Φ12',
                    unit: '吨',
                    quantity: '100',
                    unit_price: '4500.00',
                    tax_rate: '13',
                    tax_price: '5085.00'
                  },
                  {
                    category: '钢材',
                    index: 2,
                    material_name: 'Q235B螺纹钢',
                    spec_model: 'Φ16',
                    unit: '吨',
                    quantity: '150',
                    unit_price: '4450.00',
                    tax_rate: '13',
                    tax_price: '5028.50'
                  }
                ];
              }
              
} catch (err) {
              console.error('处理合同数据时出错:', err);
              this.error = '处理合同数据时出错: ' + err.message;
            }
          } else {
            console.error('API返回错误:', response.data);
            this.error = response.data?.message || '获取合同数据失败';
          }
          
          this.loading = false;
        })
        .catch(error => {
          console.error('获取合同数据出错:', error);
          this.apiError = JSON.stringify(error, null, 2);
          this.error = '获取合同数据出错: ' + (error.response?.data?.message || error.message || '未知错误');
          this.loading = false;
        });
    },
    
    // 格式化计息条件
    formatInterestConditions(contractData) {
      if (!contractData) return '未设置';
      
      let result = '';
      
      // 免息期 - 使用新API字段
      if (contractData.interestFreeDays) {
        result = `免息期：${contractData.interestFreeDays}天`;
      }
      
      // 检查是否有固定利率且不为0
      if (contractData.fixedInterestRate && contractData.fixedInterestRate !== 0) {
        if (result) result += '；';
        result += `固定利率：${contractData.fixedInterestRate}%`;
        return result;
      }
      
      // 根据interestCalculation决定是否显示"不计息"
      if (!contractData.interestCalculation) {
        if (result) result += '；';
        result += '不计息';
      }
      
      return result || '未设置利率';
    },
    
    // 映射计价方式
    mapPricingMethod(method) {
      if (!method) return '固定价';
      
      const methodMap = {
        'fixed': '固定价',
        'float': '变动价',
        'market': '市场价', // 兼容旧数据
        'negotiated': '协商价', // 兼容旧数据
        '固定价': '固定价',
        '变动价': '变动价'
      };
      return methodMap[method] || '固定价';
    },
    
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    
    // 打印合同
    async printContract() {
      // 创建一个新窗口用于打印
      const printWindow = window.open('', '_blank');
      if (!printWindow) {
        this.$message.error('打印窗口被阻止，请允许弹出窗口');
        return;
      }
      
      // 获取当前合同内容
      const contractContent = document.querySelector('.customer-contract-preview-container .contract-content');
      if (!contractContent) {
        this.$message.error('未找到合同内容');
        return;
      }
      
      // 获取合同内容的HTML
      const contentHTML = contractContent.innerHTML;
      
      // 写入打印窗口基本HTML结构
      printWindow.document.open();
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>${this.contractInfo.title || '客户合同'}</title>
          <meta charset="utf-8">
          <style>
            body {
              font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
              color: #333;
              line-height: 1.5;
              padding: 20px;
              margin: 0;
            }
            
            .contract-title {
              text-align: center;
              font-size: 22px;
              font-weight: 500;
              margin: 20px 0 30px;
            }
            
            .section-title {
              border-bottom: 2px solid #000;
              margin: 30px 0 15px;
            }
            
            .section-title h3 {
              font-size: 16px;
              font-weight: 500;
              margin: 0 0 5px 0;
            }
            
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 30px;
            }
            
            th, td {
              border: 1px solid #000;
              padding: 8px;
              text-align: center;
            }
            
            th {
              background-color: #f5f7fa;
              font-weight: 500;
            }
            
            .info-row {
              display: flex;
              width: 100%;
              border: 1px solid #000;
              border-bottom: none;
            }
            
            .info-row:last-child {
              border-bottom: 1px solid #000;
            }
            
            .info-label {
              width: 16.67%;
              background-color: #f5f7fa;
              padding: 12px 15px;
              border-right: 1px solid #000;
              font-weight: 500;
            }
            
            .info-value {
              width: 83.33%;
              padding: 12px 15px;
            }
            
            .half-width {
              width: 33.33%;
            }
            
            @page {
              size: A4 portrait;
              margin: 1cm;
            }
            
            .print-controls {
              text-align: center;
              margin: 20px 0;
              padding: 10px;
              background-color: #f5f7fa;
              border-radius: 4px;
            }
            
            .print-controls button {
              padding: 6px 16px;
              background-color: #409EFF;
              color: white;
              border: none;
              border-radius: 4px;
              cursor: pointer;
              margin: 0 5px;
              font-size: 14px;
            }
            
            .print-controls button:hover {
              background-color: #66b1ff;
            }
            
            .print-controls .close-btn {
              background-color: #909399;
            }
            
            .print-note {
              font-size: 12px;
              color: #606266;
              margin-top: 5px;
            }
            
            @media print {
              .print-controls {
                display: none;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-controls">
            <button onclick="doPrint()">打印</button>
            <button class="close-btn" onclick="window.close()">关闭窗口</button>
            <div class="print-note">打印完成后窗口将在60秒后自动关闭，或点击"关闭窗口"按钮手动关闭</div>
          </div>
          
          <div id="contract-content"></div>
        </body>
        </html>
      `);
      
      await installPlatformPrintFooter(printWindow, null, {
        documentType: 'CONTRACT',
        documentKey: this.contractId
      });
      // 关闭文档流
      printWindow.document.close();
      
      // 在窗口加载完成后注入内容和处理打印
      printWindow.onload = function() {
        // 设置合同内容
        printWindow.document.getElementById('contract-content').innerHTML = contentHTML;
        
        // 添加脚本
        const script = printWindow.document.createElement('script');
        script.textContent = `
          function doPrint() {
            window.print();
          }
          
          // 页面加载完成自动打印
          window.addEventListener('load', function() {
            window.focus();
            
            // 延迟打印，确保内容已加载
            setTimeout(function() {
      window.print();
            }, 500);
            
            // 60秒后自动关闭窗口
            setTimeout(function() {
              window.close();
            }, 60000);
          });
          
          // 尝试监听打印完成事件
          if (window.matchMedia) {
            const mediaQueryList = window.matchMedia('print');
            mediaQueryList.addEventListener('change', function(mql) {
              if (!mql.matches) {
                // 打印对话框已关闭，5秒后关闭窗口
                setTimeout(function() {
                  window.close();
                }, 5000);
              }
            });
          }
        `;
        printWindow.document.body.appendChild(script);
      };
    },
    // 映射付款方式
    mapPaymentMethod(method) {
// 在完整的合同数据中查找payment1_daynum和payment2_daynum
      const contractData = this.apiResponse ? JSON.parse(this.apiResponse).data : {};
      const payment1_daynum = contractData.payment1_daynum || '30';
      const payment2_daynum = contractData.payment2_daynum || '90';
      
// 生成详细的付款方式描述
      if (method === 'monthly' || method === '按月付款') {
        return `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`;
      }
      
      if (!method) {
return `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`;
      }
      
      const paymentMap = {
        '按季付款': `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`,
        '按月付款': `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`,
        '按周付款': `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`,
        '一次性付款': '一次性付款',
        '分期付款': '分期付款',
        '预付款': '预付款',
        '货到付款': '货到付款',
        '款到发货': '款到发货',
        'monthly': `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`,
        'quarterly': `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`,
        '其他': '其他'
      };
      
      const result = paymentMap[method] || `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`;
return result;
    },
    // 格式化付款方式
    formatPaymentMethod(method, payment1_daynum, payment2_daynum) {
// 生成详细的付款方式描述
      if (method === 'monthly' || method === '按月付款') {
        return `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`;
      }
      
      if (!method) {
return `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`;
      }
      
      const paymentMap = {
        '按季付款': `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`,
        '按月付款': `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`,
        '按周付款': `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`,
        '一次性付款': '一次性付款',
        '分期付款': '分期付款',
        '预付款': '预付款',
        '货到付款': '货到付款',
        '款到发货': '款到发货',
        'monthly': `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`,
        'quarterly': `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`,
        '其他': '其他'
      };
      
      const result = paymentMap[method] || `每${payment1_daynum}天结算金额，次月最低支付70%，${payment2_daynum}天结算金额支付至100%`;
return result;
    },
    // 格式化税率显示（添加%符号）
    formatTaxRate(value) {
      if (value === null || value === undefined || value === '') return '0%';
      const num = parseFloat(value);
      if (isNaN(num)) return '0%';
      // 如果值小于1，说明是小数形式（如0.13），转换为百分比形式（13）
      if (num < 1 && num > 0) {
        return `${Math.round(num * 100)}%`;
      }
      // 如果值大于等于1，说明已经是百分比形式（如13），直接返回
      return `${Math.round(num)}%`;
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-contract-preview-container {
  background-color: #fff;
  min-height: calc(100vh - 120px);
  
  .debug-panel {
    background-color: #fff8e1;
    border: 1px solid #ffecb3;
    padding: 15px;
    margin: 20px;
    border-radius: 4px;
    
    h3 {
      margin-top: 0;
      color: #ff9800;
    }
    
    p {
      margin: 5px 0;
      font-family: monospace;
      word-break: break-all;
      font-size: 14px;
    }
    
    .debug-actions {
      margin-top: 15px;
    }
  }
  
  .loading-container {
    margin: 20px;
    padding: 20px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  
  .contract-content {
    padding: 40px 20px 0; /* 增加上边距，将内容往下移 */
    max-width: 1180px;
    margin: 0 auto;
  }
  
  .top-nav {
    background-color: #2c73eb;
    color: white;
    padding: 10px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 -20px 20px -20px;
    
    .company-info {
      font-size: 14px;
    }
    
    .contract-info {
      background-color: white;
      color: #2c73eb;
      padding: 8px 15px;
      border-radius: 4px;
      font-size: 14px;
    }
  }
  
  .contract-title {
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    margin: 30px 0;
    color: #333;
  }
  
  .section-title {
    border-bottom: 2px solid #333;
    margin: 30px 0 15px;
    
    h3 {
      font-size: 16px;
      font-weight: 500;
      margin: 0 0 5px 0;
      color: #333;
    }
    
    .divider {
      display: none;
    }
  }
  
  .info-container {
    margin-bottom: 30px;
    border: none;
    
    .info-row {
      border: 1px solid #333;
      border-bottom: none;
      
      &:last-child {
        border-bottom: 1px solid #333;
      }
      
      .info-label {
        background-color: #f5f7fa;
        
        .label-container {
          padding: 12px 15px;
          color: #333;
          border-right: 1px solid #333;
          font-size: 14px;
        }
      }
      
      .info-value {
        .value-container {
          padding: 12px 15px;
          color: #333;
          font-size: 14px;
        }
      }
    }
  }
  
  .action-buttons {
    margin: 30px 20px;
    text-align: center;
    
    .el-button {
      min-width: 100px;
      margin: 0 10px;
    }
  }
  
  /* 表格样式 */
  >>> .el-table {
    width: 100% !important;
    margin: 0;
    
    th, td {
      border-color: #333;
      padding: 8px;
      text-align: center;
      font-size: 14px;
    }
    
    .el-table__header-wrapper th {
      background-color: #f5f7fa;
      color: #333;
      font-weight: 500;
    }
    
    .el-table__row {
      height: 40px;
    }
    
    .el-table__row:nth-child(even) {
      background-color: #fafafa;
    }
  }
  
  /* 打印样式 */
  @media print {
    .top-nav, .action-buttons, .debug-panel {
      display: none !important;
    }
    
    .info-container, .el-table {
      page-break-inside: avoid;
    }
    
    .customer-contract-preview-container {
      padding: 0 !important;
      margin: 0 !important;
      background-color: white !important;
    }
    
    ::-webkit-scrollbar {
      display: none !important;
    }
    
    .info-row, .info-label .label-container, .el-table th, .el-table td {
      border-color: #000 !important;
    }
    
    .section-title {
      border-bottom: 2px solid #000 !important;
    }
    
    >>> .el-table {
      border-color: #000 !important;
    }
  }
}
</style>
